<template>
	<svg class="svg-symbols">
		<symbol id="open-in-new-icon" viewBox="0 -960 960 960">
			<path
				d="M228.31-164q-27.01 0-45.66-18.65Q164-201.3 164-228.31v-503.38q0-27.01 18.65-45.66Q201.3-796 228.31-796h236.3v52h-236.3q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v503.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h503.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-236.3h52v236.3q0 27.01-18.65 45.66Q758.7-164 731.69-164H228.31Zm159.46-186.62-37.15-37.15L706.85-744H576v-52h220v220h-52v-130.85L387.77-350.62Z"
			/>
		</symbol>
	</svg>
</template>
